module.exports = __webpack_public_path__ + "static/media/building-with-nature-nsr-vertical.1500f88f.jpg";